import axios from 'axios'
import { errorHandler } from '../exports/error_management'

import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-checkoff-template-key'
const api = async (method, path, params) => axios[method](path, params)
const state = {
    selectedTemplate: {},
    templates: [],
}

const mutations = {
    set_template(state, payload) {
        state.selectedTemplate = payload
    },
    set_templates(state, payload) {
        state.templates = payload
    },
}

const actions = {
    /**
     * Set the selected template for a new template
     */
    newTemplate(context, payload) {
        context.commit('set_template', payload)
    },
    async create(context, payload) {
        try {
            const results = await api('post', `checkoff-template`, payload)
            const data = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                data,
                null
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, template_id) {
        try {
            const path = `checkoff-template/${template_id}`
            console.log('checkoffTemplate fetchbyId template_id', template_id)
            const results = await api('get', path)
            console.log('checkoffTemplate fetchbyId results', results)
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            console.log('err', err)
            errorHandler(err)
        }
    },

    async fetchAll(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid || (payload.forceReload && payload.forceReload === true)) {
                const results = await api('get', `checkoff-template`)
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_templates', value)
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, payload) {
        console.log('update', payload)
        try {
            const results = await api(
                'put',
                `checkoff-template/${payload.id}`,
                payload
            )
            const template = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                template,
                payload.id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, template_id) {
        try {
            await api('delete', `checkoff-template/${template_id}`)
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                null,
                template_id
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async createType(context, { template_id, item }) {
        try {
            const results = await api(
                'post',
                `checkoff-template/${template_id}/types`,
                item
            )
            const template = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                template,
                template_id
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateType(context, { template_id, item }) {
        try {
            const results = await api(
                'put',
                `checkoff-template/${template_id}/types/${item.id}`,
                item
            )
            const template = results.data.success.data
            // console.log("template",template)
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                template,
                template_id
            )
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteType(context, { template_id, item_id }) {
        try {
            const results = await api(
                'delete',
                `checkoff-template/${template_id}/types/${item_id}`
            )
            const template = results.data.success.data
            const storageCache = new StorageCache(storageKey)
            const selectionCommit = _data =>
                context.commit('set_template', _data)
            storageCache.updateSelection(
                { selectionCommit, stateList: context.state.templates },
                template,
                template_id
            )
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
